export default {
    setError(state, payload) {
        if (!payload.hasError) {
            state.formHasError = false;
            state.isExplainableError = false;
        }

        state.hasError = payload.hasError;
        state.warningPanelText = payload.warningPanelText;
    },
    setFormError(state, payload) {
        state.formHasError = true;
        state.warningPanelText = payload.warningPanelText;
        state.isExplainableError = payload.isExplainableError; 
    },
    clearFormError(state) {
        state.formHasError = false;
        state.warningPanelText = "";
        state.isExplainableError = false;
    },
    setPageStatus(state, payload) {
        state.pageIsLoading = payload;
    },
    incrementPendingRequests(state) {
        state.pendingRequestCount++;
    },
    decrementPendingRequests(state) {
        state.pendingRequestCount = Math.max(0, state.pendingRequestCount - 1);
    },
    setExplainInProgress(state, payload) {
        state.explainInProgress = payload;
    },
    setDialogOpenedStatus(state, payload) {
        state.dialogOpened = payload;
    }
}